<template>
  <div class="modal sign-modal">
    <div class="overlay" @click="$emit('closeSignUpModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeSignUpModal')" src="./../images/close.svg" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <form @submit.prevent="submitRegister" class='form-fields register-content'>
              <div class="form-fields-wrapper">
                <div class="title">{{ $t(`Create an account`) }}</div>
                <label>
                  <!-- <div class="desc">{{ $t(`*First name`) }}</div> -->
                  <input type="text" :placeholder="'*' + $t('First name')" v-model="name" @keydown="allowOnlyLetters" />
                </label>
                <label>
                  <!-- <div class="desc">{{ $t(`*Last Name`) }}</div> -->
                  <input type="text" :placeholder="'*' + $t('Last Name')" v-model="surname"
                    @keydown="allowOnlyLetters" />
                </label>
                <label>
                  <!-- <div class="desc">{{ $t(`*Email`) }}</div> -->
                  <input type="email" :placeholder="'*' + $t('Email')" v-model="email" />
                </label>
                <label v-if="countryOptionsIso && countryOptionsIso.length">
                  <!-- <div class="desc">{{ $t(`*Phone`) }}</div> -->
                  <MazPhoneNumberInput
                      v-model="phone"
                      :default-country-code="'US'"
                      show-code-on-list
                      show-example
                      color="primary"
                      @update="phoneDataUpdate"
                  />
                </label>
                <label>
                  <!-- <div class="desc">{{ $t(`*Password`) }}</div> -->
                  <input type="password" :placeholder="'*' + $t('Password')" v-model="pass" />
                </label>
                <label>
                  <!-- <div class="desc">{{ $t(`*Confirm Password`) }}</div> -->
                  <input type="password" :placeholder="'*' + $t('Confirm Password')" v-model="passConfirm" />
                </label>
                
                <label>
                  <input type="text" :placeholder="$t('Address')" v-model="address" />
                </label>

                <label>
                  <input type="text" :placeholder="$t('City')" v-model="city" />
                </label>

                <label>
                  <input type="text" :placeholder="$t('Post Code')" v-model="postCode" />
                </label>

                <label>
                  <select v-model="country" :class="{ 'select-placeholder-text': country == '' || country == null }">
                    <option selected value="">{{ $t(`Country`) }}</option>
                    <option v-for="item in countryOptions" :value="item" :key="item.iso">{{ item.name }}
                    </option>
                  </select>
                </label>

                <label>
                  <input type="text" :placeholder="$t('Referral code')" v-model="referralCode" />
                </label>

                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">{{ $t(`I agree with`) }} </span>
                        <a @click="goToPage('privacy')" class="title">{{ $t(`privacy policy`) }}</a>
                        <span class="title"> {{ $t(`and`) }} </span>
                        <a @click="goToPage('terms')" class="title">{{ $t(`terms and conditions`) }}</a>
                      </div>
                    </label>
                  </div>
                  <button :class="['button', { 'disabled': !requiredRegisterFieldsAreFilled }]" type="submit">
                    <span>{{ $t(`SIGN UP`) }}</span>
                  </button>
                </div>
                <transition name="slide">
                  <div v-if="error" class="error-desc desc red">{{ error }}</div>
                </transition>
                <div class="modal-bottom">
                  <div class="desc">{{ $t(`Have account?`) }}</div>
                  <div class="link switch-register" @click="$emit('openSignInModal')">{{ $t(`Login`) }}</div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'maz-ui/css/main.css'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SignUpModal',
  components: {
    MazPhoneNumberInput
  },
  props: [],
  emits: ['closeSignUpModal', 'openSignInModal', 'closeSignInModal', 'registration'],
  inject: ['openSignInModal', 'goToPage', 'error'],

  data: function () {
    return {
      email: '',
      pass: '',
      name: '',
      surname: '',
      phone: '',
      passConfirm: '',
      terms: false,
      phoneE164: "",
      countryOptionsIso: [],
      countryOptions: [],
      country: '',
      countryId: '',
      city: '',
      address: '',
      postCode: '',
      referralCode: '',
    }
  },

  computed: {
    requiredRegisterFieldsAreFilled() {
      return !!(
        this.name && 
        this.surname && 
        this.phone &&
        this.email && 
        this.pass && 
        this.passConfirm &&
        this.terms
      );
    }
  },

  mounted() {
    this.getCountries();
  },

  methods: {
    getDefaultCountryIso() {
      return this.phoneCountryCode || this.countryOptionsIso[0];
    },
    getCountries() {
      this.$http.get('countries')
        .then((res) => {
          this.countryOptions = res.data.payload;
          this.countryOptionsIso = res.data.payload.map(obj => obj.iso);
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal();
          }
        })
    },
    phoneDataUpdate(phoneData) {
      this.phoneE164 = phoneData?.e164 || "";
    },
    allowOnlyLetters(e) {
      const allowedCharacters = /^[^\d]+$/;
      if (!allowedCharacters.test(e.key)) {
        e.preventDefault();
      }
    },
    closeSignUpModal() {
      this.$emit('closeSignInModal')
    },
    openSignInModal() {
      this.$emit('openSignInModal')
    },
    submitRegister() {
      const registrationData = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phoneE164,
        password: this.pass,
        passConfirm: this.passConfirm,
        address: this.address,
        post_code: this.postCode,
        city: this.city,
        country_id: this.country.id,
        referral_code: this.referralCode
      };
      
      this.$emit('registration', registrationData);
    }
  },
});
</script>